<script lang="ts">
import Markdown from '@/V2/chat/components/messages/Markdown.vue';

export default {
  name: 'ChatMessageUser',
  components: { Markdown },
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
};
</script>

<template>
  <div class="chat-message-user i-text-subheading-2 i-radius-2xl i-px-6 i-py-5">
    <Markdown :content="message.content" />
  </div>
</template>

<style lang="scss" scoped>
.chat-message-user {
  max-width: 85%;
  margin-left: auto;
  text-align: left;
  background: var(--surface-neutral);
  color: var(--text-neutral-bold);
}
</style>
